import { render } from "./TableRowActions.vue?vue&type=template&id=6e595120"
import script from "./TableRowActions.vue?vue&type=script&lang=js"
export * from "./TableRowActions.vue?vue&type=script&lang=js"

import "./TableRowActions.vue?vue&type=style&index=0&id=6e595120&lang=scss"
script.render = render

export default script